export default __webpack_public_path__ + "static/media/juego2_ganar.356be8e4.png";